export default __webpack_public_path__ + "static/media/h2-icon.683b15c5.svg";